import React, { useEffect, useState, useRef } from 'react';
import { ResponsiveImage } from '../../../components/parts/ResponsiveImage'
var hoverintent = require('hoverintent');
import { gsap } from 'gsap';

const Card = ({ product, added, tryOnCount, addToCart, removeFromCart }) => {

  const cardRef = useRef(null);

  const [allowRemove, setAllowRemove] = useState(false);

  const tooltipRef = useRef(null);

  const [tootipTl, setToolTipTl] = useState(gsap.timeline({
    paused: true,
  }));

  useEffect(() => {
    if (window.matchMedia("(any-hover: hover)").matches) {
      hoverintent(
        cardRef.current,
        () => {
          tootipTl.play()
        },
        () => {
          tootipTl.reverse()
        },
        {
          timeout: 300,
          interval: 50,
        }
      )
    }
  }, [])

  useEffect(() => {
    if (added)
      setTimeout(() => {
        setAllowRemove(true)
      }, 1000);
  }, [added])

  useEffect(() => {
    if (tooltipRef.current) {
      tootipTl.set(tooltipRef.current, { y: -50, opacity: 0, immediateRender: true });
      tootipTl.to(tooltipRef.current, { display: 'block', opacity: 1, y: 0, duration: 0.3, ease: 'power.out' });
    }
  }, [tooltipRef.current])

  return (
    <>
      {product &&
        <div ref={cardRef} className="Card Card--try-on" data-layout="vertical media-content" data-added={added}>
          <figure className="Card__media">
            {ResponsiveImage({ image: product.featured_image })}
            <figcaption>
              {added ? (
                <>
                  <span className="check">
                    <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                      <use href="#check2"></use>
                    </svg>
                  </span>
                  {allowRemove &&
                    <button type="button" className="Button Button--remove" data-layout="noLayout" onClick={() => removeFromCart(product.variants[0].id)}>
                      <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                        <use href="#minus2"></use>
                      </svg>
                    </button>
                  }
                </>
              ) : (
                  <>
                    {tryOnCount < 5 &&
                      <button type="button" className="Button Button--add" data-layout="noLayout" onClick={() => addToCart(product.variants[0].id)}>
                        <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                          <use href="#plus2"></use>
                        </svg>
                      </button>
                    }
                  </>
                )}



            </figcaption>
          </figure>
          <div className="Card__details">
            <h6>{product.title}</h6>
            <div className="tooltip" ref={tooltipRef}>
              <h6>{product.title}</h6>
              <div dangerouslySetInnerHTML={{ __html: product.description }} />
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default Card

